import {
  RiEarthLine,
  RiMoneyDollarBoxLine,
  RiFileCopyLine,
  RiFileCopy2Line,
} from "react-icons/ri";

export const data = [
  {
    label: "Situation globale",
    path: "/global-situation",
    Icon: RiEarthLine,
    className: "card-1",
    // value: "25 %",
  },
  {
    label: "Etat des loyers non réglés",
    path: "/unpaid-rent",
    Icon: RiMoneyDollarBoxLine,
    className: "card-2",
    // value: "40 DT",
  },
  {
    label: "Etat des financements en cours",
    path: "/outstandings",
    Icon: RiFileCopyLine,
    className: "card-3",
    // value: "2.60 %",
  },
  {
    label: "Mes demandes",
    path: "/list-insurance-requests",
    Icon: RiFileCopy2Line,
    className: "card-4",
    // value: "60DT",
  },
];
